module.exports = __webpack_public_path__ + "img/calendar.8f60bfe8.svg";